export enum ChainId {
  ETHEREUM = 1,
  POLYGON = 137,
  BASE = 8453,
  BASE_SEPOLIA = 84532,
  BSCTEST = 97,
  SEPOLIA = 11155111,
}

export default ChainId;
